import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Landing from "./pages/index";
import Submit from "./pages/submit";
import Visit from "./pages/visit";
import HowTo from "./pages/howto";
import Claim from "./pages/claim";
import LeaderBoard from "./pages/leaderboard";


function App() {
  return (
    <Router>
      <Routes>
      <Route path="/" element={ <Navigate to="/index" />} />
      <Route path="/leaderboard" element={<LeaderBoard />} />
      <Route path="/index" element={<Landing />} />
      <Route path="/submit" element={<Submit />} />
      <Route path="/visit/:slug" element={<Visit />} />
      <Route path="/how-to-increase" element={<HowTo />} /> 
      <Route path="/claim" element={<Claim />} /> 
      </Routes>

    </Router>
  );
}

export default App;
